module.exports = __webpack_public_path__ + "img/node_buy_2.e18a3af9.webp";